import { connect } from 'react-redux';

// ducks
import { paginateThis } from '../../ducks/FavoriteSearch';

// containers
import FavoriteSearchResults from '../PropertySearch/PropertySearchResults';

export default connect((state, props) => ({}), {
  reload: paginateThis.pageActions.reload
})(FavoriteSearchResults);



// WEBPACK FOOTER //
// ./src/containers/FavoriteSearch/FavoriteSearchResults.js